import { fontStyleFragments } from './fonts'
import { notCss } from './util'

// body
// xs size
export const bodyXSRegularFragment = ` font-size: 12px; line-height: 150%; letter-spacing: 0; ${fontStyleFragments.regularNormal}` as const
export const bodyXSBoldFragment = ` font-size: 12px; line-height: 150%; letter-spacing: 0; ${fontStyleFragments.boldNormal}` as const
export const bodyXSCondensedRegularFragment =
  ` font-size: 12px; line-height: 130%; letter-spacing: 0.1px; ${fontStyleFragments.regularCondensed}` as const
export const bodyXSCondensedBoldFragment = ` font-size: 12px; line-height: 130%; letter-spacing: 0.1px; ${fontStyleFragments.boldCondensed}` as const

// s size
export const bodySRegularFragment = ` font-size: 14px; line-height: 150%; letter-spacing: 0; ${fontStyleFragments.regularNormal}` as const
export const bodySBoldFragment = ` font-size: 14px; line-height: 150%; letter-spacing: 0; ${fontStyleFragments.boldNormal}` as const
export const bodySCondensedRegularFragment =
  ` font-size: 14px; line-height: 130%; letter-spacing: 0.1px; ${fontStyleFragments.regularCondensed}` as const
export const bodySCondensedBoldFragment = ` font-size: 14px; line-height: 130%; letter-spacing: 0.1px; ${fontStyleFragments.boldCondensed}` as const
export const bodySMonospaceFragment =
  ' font-size: 16px; line-height: 130%; letter-spacing: normal;  font-weight: 400; font-family: Consolas, monospace; ' as const

// m size
export const bodyMRegularFragment = ` font-size: 16px; line-height: 150%; letter-spacing: 0; ${fontStyleFragments.regularNormal}` as const
export const bodyMBoldFragment = ` font-size: 16px; line-height: 150%; letter-spacing: 0; ${fontStyleFragments.boldNormal}` as const
export const bodyMCondensedRegularFragment =
  ` font-size: 16px; line-height: 120%; letter-spacing: normal; ${fontStyleFragments.regularCondensed}` as const
export const bodyMCondensedBoldFragment = ` font-size: 16px; line-height: 120%; letter-spacing: 0; ${fontStyleFragments.boldCondensed}` as const

// l size
export const bodyLRegularFragment = ` font-size: 18px; line-height: 150%; letter-spacing: 0; ${fontStyleFragments.regularNormal}` as const
export const bodyLBoldFragment = ` font-size: 18px; line-height: 150%; letter-spacing: 0; ${fontStyleFragments.boldNormal}` as const
export const bodyLCondensedRegularFragment = ` font-size: 18px; line-height: 120%; letter-spacing: 0; ${fontStyleFragments.regularCondensed}` as const
export const bodyLCondensedBoldFragment = ` font-size: 18px; line-height: 120%; letter-spacing: 0; ${fontStyleFragments.boldCondensed}` as const

// link
// s size
export const linkSFragment = `${bodyXSRegularFragment}text-decoration-line: underline; ` as const
// m size
export const linkMFragment = `${bodySRegularFragment}text-decoration-line: underline; ` as const
// l size
export const linkLFragment = `${bodyMRegularFragment}text-decoration-line: underline; ` as const

// heading
// xxs size
export const headlineXXSFragment =
  ` font-size: 12px; line-height: 100%; letter-spacing: 1px; text-transform: uppercase;${fontStyleFragments.boldCondensed}` as const

// xs size
export const headlineXSFragment = ` font-size: 16px; line-height: 130%; letter-spacing: 0; ${fontStyleFragments.boldCondensed}` as const
export const headlineXSSubtleFragment = ` font-size: 16px; line-height: 130%; letter-spacing: 0.1px; ${fontStyleFragments.regularCondensed}` as const
// s size
export const headlineSFragment = ` font-size: 20px; line-height: 130%; letter-spacing: 0; ${fontStyleFragments.boldCondensed}` as const
export const headlineSSubtleFragment = ` font-size: 20px; line-height: 130%; letter-spacing: 0.1px; ${fontStyleFragments.regularCondensed}` as const
// l size
export const headlineLFragment = ` font-size: 28px; line-height: 130%; letter-spacing: 0; ${fontStyleFragments.boldCondensed}` as const
export const headlineLSubtleFragment = ` font-size: 28px; line-height: 130%; letter-spacing: 0.1px; ${fontStyleFragments.regularCondensed}` as const

// homelink
export const homelinkSFragment = ` font-size: 11px; line-height: 100%; letter-spacing: 0; ${fontStyleFragments.regularNormal}` as const

// table
export const headerFragment = `font-size: 11px; line-height: 100%; ${fontStyleFragments.regularNormal}` as const
export const rowFragment = `font-size: 14px; line-height: 150%; ${fontStyleFragments.regularNormal}; letter-spacing: 0.1px;` as const
export const rowSelectedFragment = `font-size: 14px; line-height: 150%; ${fontStyleFragments.boldNormal}; letter-spacing: 0;` as const

export const bodyRoleFragments = notCss({
  xs: notCss({
    regular: bodyXSRegularFragment,
    bold: bodyXSBoldFragment,
    condensedRegular: bodyXSCondensedRegularFragment,
    condensedBold: bodyXSCondensedBoldFragment,
  } as const),
  s: notCss({
    regular: bodySRegularFragment,
    bold: bodySBoldFragment,
    condensedBold: bodySCondensedBoldFragment,
    condensedRegular: bodySCondensedRegularFragment,
    monospace: bodySMonospaceFragment,
  } as const),
  m: notCss({
    regular: bodyMRegularFragment,
    bold: bodyMBoldFragment,
    condensedBold: bodyMCondensedBoldFragment,
    condensedRegular: bodyMCondensedRegularFragment,
  } as const),
  l: notCss({
    regular: bodyLRegularFragment,
    bold: bodyLBoldFragment,
    condensedBold: bodyLCondensedBoldFragment,
  } as const),
} as const)

export const linkFragments = notCss({
  s: notCss({ regular: linkSFragment }),
  m: notCss({ linkMFragment }),
  l: notCss({ linkLFragment }),
} as const)

export const headlineFragments = notCss({
  xxs: notCss({
    regular: headlineXXSFragment,
  }),
  xs: notCss({
    regular: headlineXSFragment,
    subtle: headlineXSSubtleFragment,
  } as const),
  s: notCss({
    regular: headlineSFragment,
    subtle: headlineSSubtleFragment,
  } as const),
  l: notCss({
    regular: headlineLFragment,
    subtle: headlineLSubtleFragment,
  } as const),
} as const)

export const homelinkFragments = notCss({
  s: notCss({ regular: homelinkSFragment }),
} as const)

export const tableFragments = notCss({
  header: headerFragment,
  row: rowFragment,
  rowSelected: rowSelectedFragment,
} as const)

export const textStyleFragments = notCss({
  body: bodyRoleFragments,
  link: linkFragments,
  heading: headlineFragments,
  homelink: homelinkFragments,
  table: tableFragments,
} as const)
